<template>
  <div ref="container"></div>
</template>

<script>
export default {
  name: 'InlineScriptRenderer',
  props: {
    html: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.renderFromHtml()
  },

  watch: {
    html() {
      this.renderFromHtml()
    },
  },

  methods: {
    renderFromHtml() {
      const el = this.$refs.container
      if (!el) return
      console.log(el);
      // очистка, щоб не дублювало форму при повторному рендері
      el.innerHTML = ''

      // парсимо HTML-строку
      const wrapper = document.createElement('div')
      wrapper.innerHTML = this.html
      console.log(wrapper);

      // 1) додаємо всі ноди, крім script
      Array.from(wrapper.childNodes).forEach(node => {
        console.log(node);
        if ('SCRIPT' !== node.nodeName) {
          el.appendChild(node)
        }
      })

      // 2) виконуємо перший script, якщо він є
      const script = wrapper.querySelector('script')
      console.log(script, wrapper);
      if (script) {
        const newScript = document.createElement('script')

        // копіюємо атрибути (data-b24-form, data-skip-moving тощо)
        Array.from(script.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value)
        })

        // inline JS
        if (script.innerHTML && script.innerHTML.trim()) {
          console.log(script.innerHTML, '========');
          newScript.innerHTML = script.innerHTML
        }
        console.log(newScript);
        el.appendChild(newScript)
      }
    },
  },
}
</script>
